import { Component } from "react";
import "../styles/student_reviews.css";

class StudentReviews extends Component {
  render() {
    const statsData = [
      {
        id: 1,
        value: "1.2 M+",
        text: "hours of hands-on learning delivered across web & mobile.",
      },
      {
        id: 2,
        value: "96%",
        text: "of students said they understood concepts after just two projects.",
      },
      {
        id: 3,
        value: "800+",
        text: "individual students, schools & colleges across 12 countries participated in science fairs.",
      },
    ];

    const reviewsData = [
      {
        id: 1,
        headline: "My 8-year-old built his first robot in a week!",
        body: "ROBOX made robotics fun and approachable. The visual coding, live help, and project-based learning worked way better than any textbook.",
        author: "Priya S.",
        title: "Parent (K-12 Program)",
      },
      {
        id: 2,
        headline: "Exactly what our college club needed.",
        body: "The college-level courses were legit — ROS, AI, even IoT integration. ROBOX helped us build real prototypes and prep for competitions.",
        author: "Aniket D.",
        title: "Robotics Club Lead, VJTI",
      },
      {
        id: 3,
        headline: "Perfect for homeschooling.",
        body: "We tried several platforms, but ROBOX stood out. The support is nonstop, and my kids actually look forward to their robotics time.",
        author: "Sarah M.",
        title: "Homeschooling Parent (US)",
      },
    ];

    return (
      <section className="py-5 bg-white">
        <div className="container py-lg-5">
          {/* STATS SECTION  */}
          <div className="row g-4 justify-content-center mb-5 pb-lg-5 border-bottom">
            {statsData.map((stat) => (
              <div className="col-md-6 col-lg-4" key={stat.id}>
                <div className="stat-card h-100 text-center">
                  <h2 className="stat-value">{stat.value}</h2>
                  <p className="stat-text">{stat.text}</p>
                </div>
              </div>
            ))}
          </div>

          {/* REVIEWS SECTION  */}
          <div className="row g-5 justify-content-center pt-lg-3">
            {reviewsData.map((review) => (
              <div className="col-md-6 col-lg-4" key={review.id}>
                <div className="review-card h-100 text-center px-lg-3">
                  <div className="review-stars mb-3">
                    &#9733;&#9733;&#9733;&#9733;&#9733;
                  </div>

                  <h3 className="review-headline">{review.headline}</h3>
                  <p className="review-body">{review.body}</p>

                  <div className="mt-4">
                    <div className="author-name">&mdash; {review.author}</div>
                    <div className="author-title">{review.title}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default StudentReviews;
